import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Product } from '../product';
import { Store } from '../../store/store';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AddProductDialogueComponent } from './add-product-dialogue/add-product-dialogue.component';

@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.scss'],
})
export class AddProductComponent implements OnInit {
  @Input() store!: Store;
  @Output() addedProduct: EventEmitter<Product> = new EventEmitter<Product>();
  submitted = false;

  constructor(public dialog: MatDialog) {}

  openDialog(): void {
    const dialogRef = this.dialog.open(AddProductDialogueComponent, {
      width: '500px',
      data: { store: this.store },
    });

    dialogRef.afterClosed().subscribe((result: Product) => {
      if (result) {
        this.submitNewProduct(result);
      }
    });
  }

  ngOnInit(): void {}

  submitNewProduct(newProduct: Product): void {
    this.addedProduct.emit(newProduct);
    this.submitted = false;
  }
}
